import React from 'react';
import { Link } from 'react-router-dom';

const QuizItem = ({ quizitem }) => {
    const {id, name, logo, total } = quizitem
    return (

        <div className="mb-10 rounded-md shadow-md bg-teal-100 dark:bg-gray-900 dark:text-gray-100">
            <img src={logo} alt="" className="object-cover object-center w-full rounded-t-md lg:h-72 md:72 sm-h-16 dark:bg-gray-500" />
            <div className="flex flex-col justify-between p-6 space-y-8">
                <div className="space-y-2">
                    <h2 className="text-3xl font-semibold tracking-wide">{name}</h2>
                    <p className="dark:text-gray-100">Total:{total}</p>

                    <button className='btn btn-width bg-pink-600 px-10 py-3 rounded-xl ml-20 mt-20 '><Link to ={`/quizitem/${id}`}>Details</Link></button>
                </div>
                
                
            </div>
        </div>

    );
};

export default QuizItem;